import React, { memo, useEffect, useState } from "react";
import classnames from "classnames";
// import { City, CityLocation, CityZone } from '../../../core';
import api from "../../../api";
import "../../../styles/version-comparison-table.scss";
import { ContainerLoader } from "../../../components/loader";
import ComparisonTableBody from "./comparison-table-body";

interface VersionComparisonProps {
  parentId: string;
}

const RequirementVersionsComparison = memo((props: VersionComparisonProps) => {
  const [isLocationInfoOpen, setLocationInfoOpen] = useState(true);
  const [isAdditionalInfoOpen, setAdditionalInfoOpen] = useState(true);
  const [versionComparisonRes, setVersionComparisonRes] = useState<any>([]);
  const [viewChanges, setViewChanges] = useState<boolean>(false);
  const [changedVersionKey, setChangedVersionKey] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const { parentId } = props;


  useEffect(() => {
    setLoading(true);
    const fetchVersionsData = async () => {
      if (!viewChanges) {
        const paramss = {
          id: parentId,
          changesOnly: true,
        };
        try {
          const changedVerKeys = await api.AddNewRequirement.requirementVersionsComparisons(
            paramss
          );
          setChangedVersionKey(changedVerKeys);
        } catch (error) {
          // console.error("Failed to fetch version comparison data:", error);
        }
      }

      const params = {
        id: parentId,
        changesOnly: viewChanges,
      };
      try {
        const versionComparisonData = await api.AddNewRequirement.requirementVersionsComparisons(
          params
        );
        if (viewChanges) setChangedVersionKey(versionComparisonData);
        setVersionComparisonRes(versionComparisonData);
      } catch (error) {
        // console.error("Failed to fetch version comparison data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVersionsData();
  }, [viewChanges]);

  const renderTableHeaders = () => {
    const keys = Object.keys(versionComparisonRes).filter((key) =>
      /^v\d+$/.test(key)
    );
    return (
      <>
        <tr className="col-12">
          <th className="col-4">
            <input
              type="checkbox"
              id="viewChanges"
              name="viewChanges"
              checked={viewChanges}
              onClick={() => setViewChanges(!viewChanges)}
            />
            <label htmlFor="viewChanges"> View Only Changes</label>
            {/* <input type="checkbox" style={{ display: "block" }} /> View Only Changes */}
          </th>
          {keys.map((key) => (
            <th className="col-4" key={key}>
              {key?.toUpperCase()}
            </th>
          ))}
        </tr>
      </>
    );
  };


  return (
    <div style={{ marginBottom: "10%" }}>
      {loading ? (
        <div
          className={classnames({ "red-dot-indication": true })}
          style={{ left: "50%" }}
        >
          <ContainerLoader />
        </div>
      ) : (
        <table className="col-12 version-table ff">
          <thead>{renderTableHeaders()}</thead>
          <tbody>
            <ComparisonTableBody
              versionComparisonRes={versionComparisonRes}
              changedVersionKey={changedVersionKey}
              viewChanges={viewChanges}
              isLocationInfoOpen={isLocationInfoOpen}
              isAdditionalInfoOpen={isAdditionalInfoOpen}
              setLocationInfoOpen={setLocationInfoOpen}
              setAdditionalInfoOpen={setAdditionalInfoOpen}
            />
          </tbody>
        </table>
      )}
    </div>
  );
});

export default RequirementVersionsComparison;
